export const hotjarConfig = {
  siteId: 3774896,
  version: 6,
};
